import MarylandHeroSection from "./components/HeroSection";
import MarylandCitiesDirectory from "./components/CitiesDirectory";
import MarylandStateResources from "./components/StateResources";
import MarylandFAQSection, { faqs } from "./components/FAQSection";
import MarylandFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";
import CitySEOHead from "@/components/feature/CitySEOHead";

const marylandServices = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

export default function MarylandPage() {
  return (
    <>
      <CitySEOHead
        city="Maryland"
        state="Maryland"
        stateAbbr="MD"
        route="/states/maryland"
        title="Maryland Passport Services — Expedited & Emergency | Fast Passport Center"
        description="Expedited passport services across Maryland — Baltimore, Annapolis, Silver Spring, Columbia, Frederick. Emergency processing as fast as 24 hours. A+ BBB rated courier service."
        geoPlacename="Maryland, United States"
        geoPosition="39.0458;-76.6413"
        faqs={faqs.map((f) => ({ q: f.question, a: f.answer }))}
        servicesSchema={marylandServices}
      />
      <div className="font-sans">
        <MarylandHeroSection />
        <MarylandCitiesDirectory />
        <MarylandStateResources />
        <MarylandFAQSection />
        <SEOCrossLinks state="MD" />
        <MarylandFinalCTA />
      </div>
    </>
  );
}